import { Input, OnInit, Directive, Output, EventEmitter } from '@angular/core';
import { DrFileMeta, DrFileMetaList, FileUploadStatus } from '@app/shared/models/dr-file';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { FileTypes } from '@app/shared/models/file-type';
import { FileActions } from '@app/shared/models/file-actions';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { TemplateCategory } from '@app/shared/models/distribution-doc-models';


@Directive()
export abstract class FileListBaseComponent extends BaseWithBundleComponent implements OnInit {

    @Input()
    public fileMetaList: DrFileMetaList;

    @Input()
    public withIconAvatars: boolean;

    @Input()
    public disabledOptions: FileActions[];

    @Input()
    public dynamicDeleteBtnFn?: (file: DrFileMeta) => boolean;

    @Input()
    public cdkDropListConnectedTo?: string;

    @Input()
    public category?: TemplateCategory;

    @Output()
    public onCdkFileDropped = new EventEmitter<CdkDragDrop<string[]>>();

    get canDownload(): boolean {
        return !this.disabledOptions || this.disabledOptions.indexOf(FileActions.DOWNLOAD) === -1;
    }

    get canDelete(): boolean {
        return !this.disabledOptions || this.disabledOptions.indexOf(FileActions.DELETE) === -1;
    }

    get canView(): boolean {
        return !this.disabledOptions || this.disabledOptions.indexOf(FileActions.VIEW) === -1;
    }

    get fileStatus() {
        return FileUploadStatus;
    }

    get fileType() {
        return FileTypes;
    }

    protected constructor(protected componentServiceBundle: ComponentServiceBundle) {
        super(componentServiceBundle);
    }

    public ngOnInit() {

    }

    public fileDropped(event: CdkDragDrop<string[]>): void {
        this.onCdkFileDropped.emit(event);
    }

    public canDeleteDynamically(file: DrFileMeta): boolean {
        return !this.dynamicDeleteBtnFn || this.dynamicDeleteBtnFn(file);
    }

    public hasDeletableStatus(file: DrFileMeta): boolean {
        const deletableStatuses = [FileUploadStatus.READY, FileUploadStatus.ERROR];
        return deletableStatuses.indexOf(file.status) > -1;
    }

    public getErrorTitle(file: DrFileMeta): string {
        return `${this.translateService.instant(marker('error.file_upload'))}`;
    }
}
